import type { FetchTrucksListQuery } from '@/features/trucks/api'
import type { TrucksSearch } from '@/routes/_protected/$tenantKey/settings/trucks/-models/truck-search'

export function buildFetchTrucksQuery(
  tenantKey: string,
  deps: TrucksSearch
): FetchTrucksListQuery {
  return {
    tenantKey,
    query: {
      ...deps
    }
  }
}
